module.exports = "<tr> <td class=q-tag> {%- savedobject.facilityname  %} </td> <td>{%- savedobject.selectedbussinessunit  %}</td> <td>{%- savedobject.facilitiesuses  %}</td> <td class=q-text-right> <a href=# id=\"{%- index %}\" class=\"base-btn purple-btn v2-btn q-text-center q-marg-right-md saved-facility-remove-btn\">Remove</a> <a href=# id=\"{%- index %}\" class=\"base-btn purple-btn q-text-center saved-facility-edit-btn\">Edit</a> </td> </tr>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/maintainRetailer/html/savedFacilities.html
// module id = 1344
// module chunks = 1